﻿import { Show, Signal, createContext, createMemo, createSignal, useContext } from "solid-js";
import api from 'pxp-api/pxp-datepicker';

class PXPCalendarData { }
class PxpDatepickerContext {
    calendarData: Signal<PXPCalendarData | undefined> = createSignal<PXPCalendarData>()

    translate(key: string): string {
        return key;
    }
}

class PxpDatepickerProps {
    context?: PxpDatepickerContext
}

const pxpDatepickerContext = createContext(new PxpDatepickerContext());
export const defaultParams = new PxpDatepickerProps();
export const usePxpDatepickerContext = () => useContext(pxpDatepickerContext);

export default function PXPDatePicker(props: PxpDatepickerProps) {
    const context = createMemo(() => props.context || new PxpDatepickerContext());
    const calendarData = createMemo(() => context()?.calendarData[0]());

    <pxpDatepickerContext.Provider value={context()}>
        <Show when={calendarData()}>
            <Calendar />
        </Show>
    </pxpDatepickerContext.Provider>
}

function Calendar() {
    const ctx = usePxpDatepickerContext();

    return <div class="calendar" data-bind="with: aagCalendar">
        <div class="flexbox horizontal" style="width: 100%">
            <button type="button" class="btn btn-xs btn-default" data-bind="click: setPrevious">
                <span class="fa fa-chevron-left" role="presentation"></span>
                <span class="sr-only">{ctx.translate('Previous')}</span>
            </button>
            <button type="button" class="btn btn-xs btn-default auto" style="text-align: center; font-weight: bold" data-bind="text: monthName, click: setCurrent"></button>
            <button type="button" class="btn btn-xs btn-default" data-bind="click: setNext">
                <span class="fa fa-chevron-right" role="presentation"></span>
                <span class="sr-only">{ctx.translate('Next')}</span>
            </button>
        </div>
        <table class="cal-month-table">
            <caption class="sr-only">{ctx.translate('MonthAtAGlance')}</caption>
            <thead class="sr-only">
                <tr>
                    <th scope="col">{ctx.translate('Sun')}</th>
                    <th scope="col">{ctx.translate('Mon')}</th>
                    <th scope="col">{ctx.translate('Tue')}</th>
                    <th scope="col">{ctx.translate('Wed')}</th>
                    <th scope="col">{ctx.translate('Thu')}</th>
                    <th scope="col">{ctx.translate('Fri')}</th>
                    <th scope="col">{ctx.translate('Sat')}</th>
                </tr>
            </thead>
            <tbody data-bind="foreach: weeks">
                <tr data-bind="foreach: days">
                    <td data-bind="click: setDate, css: { otherMonth: otherMonth, 'blue-dorito': isToday }, attr: { 'data-events': eventTypes }"><div class="day">
                        <span class="date" data-bind="text: date"></span>
                    </div></td>
                </tr>
            </tbody>
        </table>
    </div>
}